import imageExists from "image-exists";
// @TODO - Remove this helper and plugins
// and replace with "lazy-img-loader" instead

let cachedThumbs = {};
export function loadImage(src, fallbackSrc, thumb = null, callback) {
  // @TODO - generate thumb SRC here
  if (thumb) {
  }

  //this is causing duplicate results for default images
  if (src in cachedThumbs) {
    return callback(cachedThumbs[src]);
  }

  imageExists(src, exist => {
    if (exist) {
      cachedThumbs[src] = src;
      callback(src);
    }
    else {
      cachedThumbs[src] = fallbackSrc;
      callback(fallbackSrc);
    }
  });
};

export function generateDummyImage(text) {
  return `https://dummyimage.com/270x270/${getRandomColor()}/ffffff.jpg&text=${text.substr(0, 2).toUpperCase()}`;
};

function getRandomColor() {
  var letters = "3456789";
  var color = "";
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 7)];
  }
  return color;
};

